import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jira_timeline_custom_issue_link_relation_names');
	},
};
